/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactWithoutAccountModel } from './ContactWithoutAccountModel';
import {
    ContactWithoutAccountModelFromJSON,
    ContactWithoutAccountModelFromJSONTyped,
    ContactWithoutAccountModelToJSON,
    ContactWithoutAccountModelToJSONTyped,
} from './ContactWithoutAccountModel';

/**
 * 
 * @export
 * @interface UserPrivateSettingsOnAzure
 */
export interface UserPrivateSettingsOnAzure {
    /**
     * 
     * @type {string}
     * @memberof UserPrivateSettingsOnAzure
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateSettingsOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserPrivateSettingsOnAzure
     */
    arc_flash_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPrivateSettingsOnAzure
     */
    fall_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPrivateSettingsOnAzure
     */
    head_impact_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPrivateSettingsOnAzure
     */
    mute_sos_button: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateSettingsOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateSettingsOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateSettingsOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserPrivateSettingsOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof UserPrivateSettingsOnAzure
     */
    _ts: number;
    /**
     * 
     * @type {{ [key: string]: ContactWithoutAccountModel; }}
     * @memberof UserPrivateSettingsOnAzure
     * @deprecated
     */
    contacts_without_accounts?: { [key: string]: ContactWithoutAccountModel; } | null;
}

/**
 * Check if a given object implements the UserPrivateSettingsOnAzure interface.
 */
export function instanceOfUserPrivateSettingsOnAzure(value: object): value is UserPrivateSettingsOnAzure {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('arc_flash_detection_on' in value) || value['arc_flash_detection_on'] === undefined) return false;
    if (!('fall_detection_on' in value) || value['fall_detection_on'] === undefined) return false;
    if (!('head_impact_detection_on' in value) || value['head_impact_detection_on'] === undefined) return false;
    if (!('mute_sos_button' in value) || value['mute_sos_button'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function UserPrivateSettingsOnAzureFromJSON(json: any): UserPrivateSettingsOnAzure {
    return UserPrivateSettingsOnAzureFromJSONTyped(json, false);
}

export function UserPrivateSettingsOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPrivateSettingsOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'org_code': json['org_code'],
        'arc_flash_detection_on': json['arc_flash_detection_on'],
        'fall_detection_on': json['fall_detection_on'],
        'head_impact_detection_on': json['head_impact_detection_on'],
        'mute_sos_button': json['mute_sos_button'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
        'contacts_without_accounts': json['contacts_without_accounts'] == null ? undefined : (mapValues(json['contacts_without_accounts'], ContactWithoutAccountModelFromJSON)),
    };
}

export function UserPrivateSettingsOnAzureToJSON(json: any): UserPrivateSettingsOnAzure {
    return UserPrivateSettingsOnAzureToJSONTyped(json, false);
}

export function UserPrivateSettingsOnAzureToJSONTyped(value?: UserPrivateSettingsOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'org_code': value['org_code'],
        'arc_flash_detection_on': value['arc_flash_detection_on'],
        'fall_detection_on': value['fall_detection_on'],
        'head_impact_detection_on': value['head_impact_detection_on'],
        'mute_sos_button': value['mute_sos_button'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
        'contacts_without_accounts': value['contacts_without_accounts'] == null ? undefined : (mapValues(value['contacts_without_accounts'], ContactWithoutAccountModelToJSON)),
    };
}

